import type { Routes } from '@angular/router';

import { ampDefaultRoutes } from '@amp/shared/app-shell';

export const appRoutes: Routes = [...ampDefaultRoutes];
